import React from "react";
import parse from "html-react-parser";

export const formatDialogJson = (dialogText, dialogJson) => {
    try {
        if (dialogJson && dialogJson.lines && dialogJson.lines.length > 0) {
            const result = [];
            let key = 0;

            for (let i = 0; i < dialogJson.lines.length; i++) {
                const element = dialogJson.lines[i];

                // handling line breaks
                if (element.nl) {
                    for (let nl = 0; nl < element.nl; nl++) {
                        result.push(<br key={`br-${key++}`} />);
                    }
                }

                // handling tables
                if (element.table && element.data) {
                    const elementsTr = getTableBodyTRs(element.data);

                    result.push(
                        <div
                            key={`table-${key++}`}
                            style={{
                                margin: "1em 0",
                                overflowX: "auto",
                            }}
                        >
                            <table>
                                <thead>
                                    <tr>
                                        {element.table.map((value, index) => (
                                            <th key={`th-${index}`}>{value}</th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>{elementsTr}</tbody>
                            </table>
                        </div>,
                    );
                }
                // handling values
                else if (element.value) {
                    const value = element.value;
                    const style = element.style || {};
                    result.push(
                        <div key={`value-${key++}`} style={style}>
                            {parse(value)}
                        </div>,
                    );
                }
            }

            return (
                <div
                    style={{
                        fontSize: "1rem",
                        lineHeight: "1.5",
                    }}
                >
                    {result}
                </div>
            );
        }
    } catch (e) {
        console.error("formatText failed!", e, dialogJson);
    }

    // fallback to plain text
    return <p>{dialogText}</p>;
};

const getTableBodyTRs = (data) => {
    const elementsTr = [];
    if (data) {
        for (let i = 0; i < data.length; i++) {
            const elementsTd = [];
            const values = data[i];

            for (let td = 0; td < values.length; td++) {
                elementsTd.push(<td key={td}>{values[td]}</td>);
            }
            elementsTr.push(<tr key={i}>{elementsTd}</tr>);
        }
    }
    return elementsTr;
};
